import React, { useEffect, useRef, useState } from "react";
import { tractionMetrics } from "../../data/companyData";
import "./SaasSections.css";

function AnimatedCounter({ value, suffix, isVisible }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    const start = 0;
    const duration = 1500;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(start + (value - start) * eased));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [value, isVisible]);

  return (
    <span>
      {count}
      {suffix}
    </span>
  );
}

export default function TractionSection() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="saas-section traction-section"
      id="traction-section"
      ref={sectionRef}
    >
      <h2 className="saas-section__title">TRACTION</h2>
      <div className="saas-section__header">
        <p className="saas-section__intro">
          Serving early customers across HRTech and EdTech sectors in India with scalable SaaS solutions.
        </p>
      </div>
      <div className="traction-grid">
        {tractionMetrics.map((metric) => (
          <div key={metric.label} className="traction-card">
            <div className="traction-card__value">
              <AnimatedCounter
                value={metric.value}
                suffix={metric.suffix}
                isVisible={isVisible}
              />
            </div>
            <p className="traction-card__label">{metric.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
